import { FontFamily, TypographyToken } from '@/theme/typography';
import { ReactNode } from 'react';
import { TextProps as RNTextProps, TextStyle } from 'react-native';

export type TextVariant = TypographyToken;

export type TextProps = RNTextProps & {
  children: ReactNode;
  /**
   * Typography variant, mapped directly to a key in `theme.typography`.
   * Defaults to `Font Inter/Body/Regular 16px`.
   */
  variant?: TextVariant;
  /**
   * Override the font family from the typography variant.
   * Accepts `'Inter'` or `'Montserrat'`.
   */
  fontFamily?: FontFamily;
  /**
   * Override font size from the typography variant.
   */
  fontSize?: TextStyle['fontSize'];
  /**
   * Override font weight from the typography variant.
   */
  fontWeight?: TextStyle['fontWeight'];
  /**
   * Override line height from the typography variant.
   */
  lineHeight?: TextStyle['lineHeight'];
  /**
   * Override letter spacing from the typography variant.
   */
  letterSpacing?: TextStyle['letterSpacing'];
  /**
   * Override text transform from the typography variant.
   */
  transform?: TextStyle['textTransform'];
  /**
   * Override font style from the typography variant.
   */
  fontStyle?: TextStyle['fontStyle'];
};
